<template>
  <div class="avatar__head">
    <AvatarFull head />
  </div>
</template>

<script>
import AvatarFull from '@/components/avatar/AvatarFull.vue'

export default {
  name: 'AvatarFace',
  components: { AvatarFull },
}
</script>
